import { TFunction } from 'i18next';
import { Site } from 'graphql-common';
import Icons from '@lib/components/Icons/Icons';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';

type ActionsMenuArgs = {
  isViewOnly: boolean;
  onDeleteHandler: (v?: Site) => void;
  onEditHandler: (v?: Site) => void;
  onViewHandler: (v?: Site) => void;
  t: TFunction<'translation', undefined>;
};

export default function getSitesTableActionsMenu({
  isViewOnly,
  onDeleteHandler,
  onEditHandler,
  onViewHandler,
  t,
}: ActionsMenuArgs): NavItem<Site>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      leftIcon: Icons.view,
      onClick: (item?: Site) => onViewHandler(item),
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      leftIcon: Icons.edit,
      onClick: (item?: Site) => onEditHandler(item),
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      // predictorFnDisable: (item?: Site) => !!item?.readOnly,
      // predictorFnDisableTooltipProps: (item?: Site) =>
      //   item?.readOnly
      //     ? ({
      //         body: t('Site-default-disabled-edit-desc'),
      //         placement: 'left',
      //       } as Omit<TooltipProps, 'children'>)
      //     : undefined,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      leftIcon: Icons.delete,
      onClick: (item?: Site) => onDeleteHandler(item),
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      // predictorFnDisable: (item?: Site) =>
      //   _get(item, 'canDestroy.value', true) === false || !!item?.readOnly,
      // predictorFnDisableTooltipProps: (item?: Site) => {
      //   if (item?.readOnly) {
      //     return {
      //       body: t('Site-default-disabled-destroy-desc'),
      //       placement: 'left',
      //     };
      //   }
      //   if (!item?.canDestroy?.value) {
      //     return {
      //       body: t('Site-disabled-destroy-desc'),
      //       placement: 'left',
      //     };
      //   }
      //   return undefined;
      // },
    },
  ];
}
